export default __webpack_public_path__ + "cb0f9e63ee7e73c2a5ebabc2d3793d7e.svg";